var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['container', _vm._isMobile() ? 'mobile' : '']},[_c('Header'),_c('div',{staticClass:"banner-wrap"},[_c('Banner',{staticClass:"banner"})],1),_c('div',{staticClass:"home"},[_c('router-view')],1),_c('a-back-top'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }